import { FunctionComponent, useState } from "react";
import { useFirestore, useFirestoreDocData } from "reactfire";
import { doc } from "firebase/firestore";
import { CircularProgress, Stack, Typography } from "@mui/material";

import { useFirestoreBasePath } from "../../hooks/useFirestoreBasePath";
import { usePlayerDetails } from "../../hooks/usePlayerDetails";
import { useCompSeasonId } from "../../hooks/useCompSeasonId";
import { useUfflUsers } from "../../hooks/useUfflUsers";
import { ufflUserRoundConverter } from "../../models/round";
import { LineupSelectionForm } from "./LineupSelectionForm";
import { useAflRounds } from "../../hooks/useAflRounds";

interface LineupSelectionDataProps {
  roundId: string;
  userId: string;
}

export const LineupSelectionData: FunctionComponent<LineupSelectionDataProps> = ({ roundId, userId }) => {
  const compSeasonId = useCompSeasonId();
  const firestoreBasePath = useFirestoreBasePath();
  const { selectByIds } = usePlayerDetails(compSeasonId);
  const { selectById: selectUser } = useUfflUsers();
  const { selectById: selectRound } = useAflRounds(compSeasonId);

  const [
    editMode
    // setEditMode
  ] = useState(true);

  const roundName = selectRound(roundId)?.name;
  const teamName = selectUser(userId)?.teamName;

  const docRef = doc(
    useFirestore(),
    firestoreBasePath,
    "uffl",
    "compSeasons",
    compSeasonId,
    "rounds",
    roundId,
    "teams",
    userId
  ).withConverter(ufflUserRoundConverter);

  const { status, data } = useFirestoreDocData(docRef, { idField: "uid" });

  const displayItems = selectByIds(data?.players ?? []);

  return status === "loading" ? (
    <CircularProgress />
  ) : (
    <Stack justifyContent="center">
      {
        <Typography variant="h6" align="center">
          Lineup for {roundName ?? roundId}
        </Typography>
      }
      {
        <Typography sx={{ mb: 2 }} variant="body2" color="text.secondary" component="div" align="center">
          {teamName ?? "Unknown"}
        </Typography>
      }
      <LineupSelectionForm docRef={docRef} lineup={data?.lineup} displayItems={displayItems} editMode={editMode} />
    </Stack>
  );
};
